exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{color:#666}small,strong,time{color:#888}strong{margin-left:10px}h2,h4{color:#333}h4.overh4{color:#fff}h5{font-weight:300;font-size:20px}li{padding:25px 0}section{padding:20px 0}.border-bottom{border-bottom:1px solid #eee}section.home{padding-top:200px;text-align:center}section.home button{border-top-left-radius:0;border-bottom-left-radius:0}section.stats{text-align:center}section.stats span{display:inline-block;width:80px}section.stats h2{margin:0}section.orgs img{border-radius:3px;margin:5px;width:42px;height:42px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./assets/styles.css
// module id = 169
// module chunks = 0